import { RouteRecordRaw } from 'vue-router'
const Login = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/Login.vue')
const PasswordRecovery = () =>
  import(
    /* webpackChunkName: "login-view" */ './views/pages/PasswordRecovery.vue'
  )
const PasswordRecoveryRequest = () =>
  import(
    /* webpackChunkName: "login-view" */ './views/pages/PasswordRecoveryRequest.vue'
  )

const PasswordRecoveryConfirmation = () =>
  import(
    /* webpackChunkName: "login-view" */ './views/pages/PasswordRecoveryConfirmation.vue'
  )

export const authModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Sign in',
    },
  },
  {
    path: 'password-recovery-request',
    name: 'passwordRecoveryRequest',
    component: PasswordRecoveryRequest,
  },
  {
    path: 'password-recovery-confirmation',
    name: 'passwordRecoveryConfirmation',
    component: PasswordRecoveryConfirmation,
  },
  {
    path: 'password-recovery/:token',
    name: 'passwordRecovery',
    component: PasswordRecovery,
  },
]
